import React from "react";
import { ChevronRight } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import LogoIconContainer from "@/components/ui/logo-icon-container";
import Text from "@/components/ui/text";
import { ProductV2 } from "../types";

interface ProductListCardProps {
  product: ProductV2;
  index: number;
  onOpen: (product: ProductV2) => void;
}

export const ProductListCard: React.FC<ProductListCardProps> = ({
  product,
  index,
  onOpen
}) => (
  <button
    type="button"
    onClick={() => onOpen(product)}
    className="flex w-full items-center gap-3 rounded-2xl border-[0.5px] border-border-widget-card bg-surface-widget-card p-4 text-left transition-colors hover:bg-surface-widget-card-hover focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary"
    data-test={`products-list-card-${product.id}`}
  >
    <LogoIconContainer index={index} />
    <div className="flex min-w-0 flex-1 flex-col">
      <Text variant="body" className="truncate">
        {product.name}
      </Text>
      <Text variant="smBodySecondary" className="truncate">
        {product.description}
      </Text>
    </div>
    <IconContainer size="md" color="secondary">
      <ChevronRight />
    </IconContainer>
  </button>
);
